import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  errorMessage,
  deleteApplicantInterview,
  employerApplicationsKey,
  applicationsCountsKey,
  applicationHistoryKey,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { eventsInterviewKey } from '@features/events';

type useDeleteSpecificInterviewProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useDeleteSpecificInterview = ({
  setErrorText = () => { },
}: useDeleteSpecificInterviewProps) => {
  const client = useQueryClient();

  const { mutate: deleteInterview, isLoading: isDeletingInterview } =
    useMutation({
      mutationFn: (variables: {
        calendar_item?: number;
        application_id: number | string;
        calendar_block_invite?: number | string;
      }) =>
        axiosInstance
          .post(deleteApplicantInterview, variables, {
          })
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          setErrorText('');
          client.invalidateQueries(employerApplicationsKey);
          client.invalidateQueries(applicationsCountsKey);
          client.invalidateQueries(eventsInterviewKey);
          client.invalidateQueries(applicationHistoryKey);
        }
      },
      onError: () => {
        setErrorText(errorMessage);
      },
    });

  return {
    deleteInterview,
    isDeletingInterview,
  };
};
